import { ContactTypeId, Currencies } from '@constants/enums';
import { COUNTRY_CURRENCY } from '@efex-components/common/Form/config';

type UseForwardPaymentProps = {
  currency: Currencies;
  desCurrency: Currencies;
  contactTypeId?: ContactTypeId;
};

type UseForwardPayment = {
  isForwardVisible: boolean;
};

const useForwardPayment = ({
  currency,
  desCurrency,
  contactTypeId,
}: UseForwardPaymentProps): UseForwardPayment => {
  const isSameCurrency = currency === desCurrency;
  const isSwiftContact = contactTypeId === ContactTypeId.SWIFT_CONTACT;
  const isUSDtoMXN =
    currency === COUNTRY_CURRENCY.USA && desCurrency === COUNTRY_CURRENCY.MX;
  const isMXNtoUSD =
    currency === COUNTRY_CURRENCY.MX && desCurrency === COUNTRY_CURRENCY.USA;

  const isForwardVisible =
    !isSameCurrency && !isSwiftContact && (isUSDtoMXN || isMXNtoUSD);

  return { isForwardVisible };
};

export default useForwardPayment;
